import { gql } from '@apollo/client';

export default gql`
  mutation removeAffiliateSeller {
    payload: removeAffiliate {
      ... on RemoveAffiliateSuccess {
        successful
      }

      ... on RemoveAffiliateFailure {
        successful
      }
    }
  }
`;
